module.exports = __webpack_public_path__ + "img/AHM Icon Logo New.f935e179.png";